
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.764 5.308c0 2.919 2.388 5.307 5.308 5.307 2.919 0 5.307-2.388 5.307-5.307C12.38 2.388 9.991 0 7.072 0c-2.92 0-5.308 2.388-5.308 5.308zm9.366 0a4.07 4.07 0 01-4.058 4.058 4.07 4.07 0 01-4.06-4.058 4.07 4.07 0 014.06-4.06 4.07 4.07 0 014.058 4.06zM.89 16.297a8.665 8.665 0 016.182-2.56c2.341 0 4.527.905 6.181 2.56l.89-.89a9.994 9.994 0 00-7.071-2.919A9.994 9.994 0 000 15.408l.89.89z","fill":"#6964F8"}})])
          )
        }
      }
    